import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { OnboardingLayout } from '../Layout';
import { paths } from '@/routes/paths';
import { useFamily } from '@/api/queries/family';
import { Spinner } from '@/components/ui/Spinner';

export function OnboardingFamilyEmptyPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const family = useFamily();

  if (family.isLoading) {
    return (
      <OnboardingLayout back title={t('onboarding.family.empty_title')}>
        <Spinner />
      </OnboardingLayout>
    );
  }

  // If list isn't empty, push to list view.
  if (family.data && family.data.length > 0) {
    navigate(paths.onboardingFamilyList, { replace: true });
  }

  return (
    <OnboardingLayout back title={t('onboarding.family.empty_title')}>
      <EmptyState
        icon="👨‍👩‍👧"
        title={t('onboarding.family.empty_title')}
        body={t('onboarding.family.empty_body')}
        action={
          <Button block size="lg" variant="inverted" onClick={() => navigate(paths.onboardingFamilyForm)}>
            {t('onboarding.family.add')}
          </Button>
        }
      />
      <Button block variant="ghost" onClick={() => navigate(paths.onboardingPaymentEmpty)}>
        {t('common.skip')}
      </Button>
    </OnboardingLayout>
  );
}
